
import APIClient from './APIClient'

class CLogAPI {

  async list() {
    const res = await APIClient.GET('/log')
    return res
  }

}

const LogAPI = new CLogAPI()

export default LogAPI



// WEBPACK FOOTER //
// ./src/api/LogAPI.js